// Translations for Clean-Force website
// Supported languages: nl (Dutch), en (English), fr (French), de (German)

const translations = {
  nl: {
    // Navigation
    nav: {
      home: "Home",
      services: "Diensten",
      about: "Over Ons",
      reviews: "Reviews",
      quote: "Offerte",
      requestQuote: "Offerte Aanvragen"
    },
    // Hero Section
    hero: {
      badge: "Professioneel Schoonmaakbedrijf",
      title1: "Vlekkeloze",
      title2: "Schoonmaak",
      title3: "Gegarandeerd",
      description: "Betrouwbare en kwalitatieve schoonmaakoplossingen voor bedrijven in Nederland en België. Kwaliteit en klanttevredenheid staan voorop.",
      cta1: "Gratis Offerte",
      cta2: "Onze Diensten",
      banner: "Bereken direct uw prijs via onze chatbot",
      bannerSub: "Ontvang een exacte prijsberekening op basis van uw situatie",
      bannerCta: "Start Prijsberekening",
      stats: {
        founded: "Opgericht",
        retention: "Klantbehoud",
        activeIn: "Actief In"
      }
    },
    // Services Section
    services: {
      badge: "Onze Diensten",
      title1: "Schoonmaakoplossingen",
      title2: "Op Maat",
      vacation: {
        title: "Vakantiehuizen Service",
        description: "Complete schoonmaak, wasserij én check-in van gasten voor vakantiewoningen."
      },
      office: {
        title: "Kantoorschoonmaak",
        description: "Professionele reiniging van kantoorruimtes voor een productieve werkomgeving."
      },
      industrial: {
        title: "Industriële Reiniging",
        description: "Specialistische schoonmaak voor fabrieken, magazijnen en productieruimtes."
      },
      osmosis: {
        title: "Ramenwassen met Osmose",
        description: "Streepvrije resultaten met zuiver osmosewater. Veilig en milieuvriendelijk tot grote hoogtes."
      },
      solar: {
        title: "Zonnepanelen Reiniging",
        description: "Verhoog het rendement van uw zonnepanelen met professionele reiniging. Tot 30% meer opbrengst."
      },
      laundry: {
        title: "Wasserijdiensten",
        description: "Textielverzorging op maat via HomeCareService voor al uw wasserijbehoeften."
      },
      windows: {
        title: "Glazenwassen Traditioneel",
        description: "Klassiek glazenwassen voor kristalheldere ramen op elke locatie."
      },
      sanitation: {
        title: "Sanering & Desinfectie",
        description: "Professionele schoonmaak na verstopte toiletten, buisbreuk en afvalwateroverlast."
      },
      construction: {
        title: "Bouwoplevering Schoonmaak",
        description: "Instapklare opleveringsschoonmaak na nieuwbouw of renovatie. Grondig en professioneel."
      },
      moveout: {
        title: "Schoonmaak na Verhuur/Verkoop",
        description: "Woning instapklaar opleveren na verhuur, verkoop of verhuis. Van studio tot villa."
      },
      deepclean: {
        title: "Deep Clean Schoonmaak",
        description: "Grondige dieptereiniging voor woningen en panden. Van normaal onderhoud tot extreme vervuiling."
      }
    },
    // Features Section
    features: {
      badge: "Waarom Clean-Force",
      title1: "Uw Partner in",
      title2: "Professionele Hygiëne",
      description: "Sinds 2021 bieden wij betrouwbare en kwalitatieve schoonmaakoplossingen voor bedrijven in Nederland en België. Onze trouwe klanten kiezen jaar na jaar voor Clean-Force - dat zegt alles over onze kwaliteit.",
      reliability: {
        title: "Betrouwbaarheid",
        description: "Gecertificeerd personeel met achtergrondcontrole voor uw gemoedsrust."
      },
      flexibility: {
        title: "Flexibiliteit",
        description: "Aanpasbare schema's die passen bij uw bedrijfsvoering."
      },
      quality: {
        title: "Kwaliteit",
        description: "Hoogwaardige resultaten met moderne technieken en middelen."
      },
      satisfaction: {
        title: "Klanttevredenheid",
        description: "Persoonlijke aandacht en snelle communicatie gegarandeerd."
      }
    },
    // Reviews Section
    reviews: {
      badge: "Google Reviews",
      title1: "Wat Onze Klanten",
      title2: "Zeggen",
      reviewsOn: "reviews op Google",
      poweredBy: "Powered by Google",
      viewAll: "Bekijk alle reviews op Google",
      qrTitle: "Tevreden over onze service?",
      qrDescription: "Scan de QR code om een review achter te laten",
      qrLink: "hier"
    },
    // Portfolio Section
    portfolio: {
      badge: "Ons Werk",
      title1: "Recente",
      title2: "Projecten",
      description: "Bekijk onze recente sanerings- en desinfectiewerkzaamheden. Deze foto's tonen situaties waarin Clean-Force is ingeschakeld voor professionele schoonmaak en desinfectie.",
      category: "Sanering & Desinfectie",
      cta: "Ook hulp nodig?",
      ctaButton: "Neem Contact Op"
    },
    gallery: {
      badge: "Resultaten",
      title1: "Voor &",
      title2: "Na",
      description: "Bekijk het verschil dat Clean-Force maakt. Schuif de slider om het resultaat te zien.",
      empty: "Binnenkort beschikbaar — onze klanten delen hun resultaten.",
      cta: "Wilt u ook zo'n resultaat?",
      ctaButton: "Offerte Aanvragen",
      permission: "Met toestemming van de klant"
    },
    // Quote Form
    quote: {
      badge: "Gratis Offerte",
      title1: "Vraag Uw",
      title2: "Offerte Aan",
      success: {
        title: "Bedankt!",
        message: "Uw offerteaanvraag is ontvangen. We nemen spoedig contact met u op.",
        newRequest: "Nieuwe Aanvraag"
      },
      form: {
        name: "Naam",
        namePlaceholder: "Uw naam",
        email: "Email",
        emailPlaceholder: "uw@email.nl",
        phone: "Telefoon",
        phonePlaceholder: "+31 6 12345678",
        company: "Bedrijfsnaam",
        companyPlaceholder: "Uw bedrijf (optioneel)",
        serviceType: "Type Dienst",
        selectService: "Selecteer een dienst",
        frequency: "Frequentie",
        selectFrequency: "Selecteer frequentie",
        details: "Aanvullende Details",
        detailsPlaceholder: "Beschrijf uw wensen en situatie...",
        submit: "Offerte Aanvragen",
        submitting: "Verzenden..."
      },
      services: {
        vacation: "Vakantiehuizen Service",
        office: "Kantoorschoonmaak",
        industrial: "Industriële Reiniging",
        osmosis: "Ramenwassen met Osmose",
        solar: "Zonnepanelen Reiniging",
        windows: "Glazenwassen Traditioneel",
        laundry: "Wasserijdiensten",
        other: "Anders"
      },
      frequencies: {
        onCall: "Op afroep (vakantiehuizen)",
        daily: "Dagelijks",
        weekly: "Wekelijks",
        biweekly: "Tweewekelijks",
        monthly: "Maandelijks",
        once: "Eenmalig"
      }
    },
    // Footer
    footer: {
      description: "Clean-Force BV biedt professionele schoonmaakdiensten en wasserijoplossingen voor bedrijven in Nederland en België. Kwaliteit en betrouwbaarheid staan centraal.",
      quickLinks: "Snelle Links",
      contact: "Contact",
      rights: "Alle rechten voorbehouden.",
      terms: "Algemene Voorwaarden",
      privacy: "Privacyverklaring"
    },
    // Blog
    blog: {
      badge: "Blog",
      title: "Kennis & Tips",
      subtitle: "Praktische artikelen over professionele schoonmaak, onderhoud en hygiëne",
      readMore: "Lees meer",
      backToBlog: "Terug naar blog",
      backToHome: "Terug naar home",
      publishedOn: "Gepubliceerd op",
      by: "door",
      relatedArticles: "Gerelateerde artikelen",
      noArticles: "Nog geen artikelen beschikbaar.",
      categories: {
        ramenwassen: "Ramenwassen",
        zonnepanelen: "Zonnepanelen",
        kantoorschoonmaak: "Kantoorschoonmaak",
        sanering: "Sanering"
      }
    },
    // Chat
    chat: {
      title: "Clean-Force Assistent",
      online: "Online",
      welcome: "Welkom bij Clean-Force! Ik ben uw virtuele assistent. Hoe kan ik u vandaag helpen? Vraag gerust naar onze diensten, prijzen, of locaties.",
      placeholder: "Typ uw vraag...",
      error: "Sorry, er is iets misgegaan. Probeer het later opnieuw of neem direct contact met ons op via 085/115.5757 (NL), 06 11 28 43 00 (NL Mobiel) of 0484/448.854 (BE).",
      priceCalculation: "Vraag een exacte prijsberekening via onze chat assistent!",
      priceDescription: "Onze AI-assistent berekent direct uw prijs op basis van aantal ramen, locatie en frequentie."
    },
    // Service Pages
    servicePage: {
      backToHome: "Terug naar Home",
      benefits: "Voordelen",
      whatWeOffer: "Wat wij bieden",
      pricing: "Prijzen",
      interested: "Interesse in",
      contactUs: "Neem contact met ons op voor een vrijblijvende offerte of stel uw vraag via onze chat assistent.",
      requestQuote: "Offerte Aanvragen",
      callBE: "BE: 0484/448.854",
      callNL: "NL: 085/115.5757",
      callNLMob: "NL Mobiel: 06 11 28 43 00",
      emailUs: "Of mail naar:"
    }
  },
  
  en: {
    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      about: "About Us",
      reviews: "Reviews",
      quote: "Quote",
      requestQuote: "Request Quote"
    },
    // Hero Section
    hero: {
      badge: "Professional Cleaning Company",
      title1: "Spotless",
      title2: "Cleaning",
      title3: "Guaranteed",
      description: "Reliable and quality cleaning solutions for businesses in the Netherlands and Belgium. Quality and customer satisfaction come first.",
      cta1: "Free Quote",
      cta2: "Our Services",
      banner: "Calculate your price instantly via our chatbot",
      bannerSub: "Get an exact price calculation based on your situation",
      bannerCta: "Start Price Calculation",
      stats: {
        founded: "Founded",
        retention: "Client Retention",
        activeIn: "Active In"
      }
    },
    // Services Section
    services: {
      badge: "Our Services",
      title1: "Cleaning Solutions",
      title2: "Tailored",
      vacation: {
        title: "Vacation Home Service",
        description: "Complete cleaning, laundry and guest check-in for vacation rentals."
      },
      office: {
        title: "Office Cleaning",
        description: "Professional cleaning of office spaces for a productive work environment."
      },
      industrial: {
        title: "Industrial Cleaning",
        description: "Specialist cleaning for factories, warehouses and production facilities."
      },
      osmosis: {
        title: "Osmosis Window Cleaning",
        description: "Streak-free results with pure osmosis water. Safe and eco-friendly up to great heights."
      },
      solar: {
        title: "Solar Panel Cleaning",
        description: "Increase the efficiency of your solar panels with professional cleaning. Up to 30% more yield."
      },
      laundry: {
        title: "Laundry Services",
        description: "Customized textile care via HomeCareService for all your laundry needs."
      },
      windows: {
        title: "Traditional Window Cleaning",
        description: "Classic window cleaning for crystal clear windows at any location."
      },
      sanitation: {
        title: "Sanitation & Disinfection",
        description: "Professional cleaning after toilet blockages, pipe bursts and sewage water damage."
      },
      construction: {
        title: "Post-Construction Cleaning",
        description: "Move-in ready handover cleaning after new builds or renovations. Thorough and professional."
      },
      moveout: {
        title: "Move-Out / Sale Cleaning",
        description: "Property ready for handover after rental, sale or moving. From studio to villa."
      },
      deepclean: {
        title: "Deep Clean",
        description: "Thorough deep cleaning for homes and properties. From regular maintenance to extreme contamination."
      }
    },
    // Features Section
    features: {
      badge: "Why Clean-Force",
      title1: "Your Partner in",
      title2: "Professional Hygiene",
      description: "Since 2021, we offer reliable and quality cleaning solutions for businesses in the Netherlands and Belgium. Our loyal customers choose Clean-Force year after year - that says it all about our quality.",
      reliability: {
        title: "Reliability",
        description: "Certified staff with background checks for your peace of mind."
      },
      flexibility: {
        title: "Flexibility",
        description: "Customizable schedules that fit your business operations."
      },
      quality: {
        title: "Quality",
        description: "High-quality results with modern techniques and resources."
      },
      satisfaction: {
        title: "Customer Satisfaction",
        description: "Personal attention and fast communication guaranteed."
      }
    },
    // Reviews Section
    reviews: {
      badge: "Google Reviews",
      title1: "What Our Customers",
      title2: "Say",
      reviewsOn: "reviews on Google",
      poweredBy: "Powered by Google",
      viewAll: "View all reviews on Google",
      qrTitle: "Satisfied with our service?",
      qrDescription: "Scan the QR code to leave a review",
      qrLink: "here"
    },
    // Portfolio Section
    portfolio: {
      badge: "Our Work",
      title1: "Recent",
      title2: "Projects",
      description: "View our recent remediation and disinfection work. These photos show situations where Clean-Force was called in for professional cleaning and disinfection.",
      category: "Remediation & Disinfection",
      cta: "Need help too?",
      ctaButton: "Contact Us"
    },
    gallery: {
      badge: "Results",
      title1: "Before &",
      title2: "After",
      description: "See the difference Clean-Force makes. Slide to compare before and after.",
      empty: "Coming soon — our clients are sharing their results.",
      cta: "Want results like these?",
      ctaButton: "Request Quote",
      permission: "Shared with client permission"
    },
    // Quote Form
    quote: {
      badge: "Free Quote",
      title1: "Request Your",
      title2: "Quote",
      success: {
        title: "Thank You!",
        message: "Your quote request has been received. We will contact you shortly.",
        newRequest: "New Request"
      },
      form: {
        name: "Name",
        namePlaceholder: "Your name",
        email: "Email",
        emailPlaceholder: "your@email.com",
        phone: "Phone",
        phonePlaceholder: "+31 6 12345678",
        company: "Company Name",
        companyPlaceholder: "Your company (optional)",
        serviceType: "Service Type",
        selectService: "Select a service",
        frequency: "Frequency",
        selectFrequency: "Select frequency",
        details: "Additional Details",
        detailsPlaceholder: "Describe your needs and situation...",
        submit: "Request Quote",
        submitting: "Sending..."
      },
      services: {
        vacation: "Vacation Home Service",
        office: "Office Cleaning",
        industrial: "Industrial Cleaning",
        osmosis: "Osmosis Window Cleaning",
        solar: "Solar Panel Cleaning",
        windows: "Traditional Window Cleaning",
        laundry: "Laundry Services",
        other: "Other"
      },
      frequencies: {
        onCall: "On call (vacation homes)",
        daily: "Daily",
        weekly: "Weekly",
        biweekly: "Bi-weekly",
        monthly: "Monthly",
        once: "One-time"
      }
    },
    // Footer
    footer: {
      description: "Clean-Force BV offers professional cleaning services and laundry solutions for businesses in the Netherlands and Belgium. Quality and reliability are central.",
      quickLinks: "Quick Links",
      contact: "Contact",
      rights: "All rights reserved.",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy"
    },
    // Blog
    blog: {
      badge: "Blog",
      title: "Knowledge & Tips",
      subtitle: "Practical articles about professional cleaning, maintenance and hygiene",
      readMore: "Read more",
      backToBlog: "Back to blog",
      backToHome: "Back to home",
      publishedOn: "Published on",
      by: "by",
      relatedArticles: "Related articles",
      noArticles: "No articles available yet.",
      categories: {
        ramenwassen: "Window Cleaning",
        zonnepanelen: "Solar Panels",
        kantoorschoonmaak: "Office Cleaning",
        sanering: "Remediation"
      }
    },
    // Chat
    chat: {
      title: "Clean-Force Assistant",
      online: "Online",
      welcome: "Welcome to Clean-Force! I am your virtual assistant. How can I help you today? Feel free to ask about our services, prices, or locations.",
      placeholder: "Type your question...",
      error: "Sorry, something went wrong. Please try again later or contact us directly at 085/115.5757 (NL), 06 11 28 43 00 (NL Mobile) or 0484/448.854 (BE).",
      priceCalculation: "Request an exact price calculation via our chat assistant!",
      priceDescription: "Our AI assistant calculates your price directly based on number of windows, location and frequency."
    },
    // Service Pages
    servicePage: {
      backToHome: "Back to Home",
      benefits: "Benefits",
      whatWeOffer: "What We Offer",
      pricing: "Pricing",
      interested: "Interested in",
      contactUs: "Contact us for a free quote or ask your question via our chat assistant.",
      requestQuote: "Request Quote",
      callBE: "BE: 0484/448.854",
      callNL: "NL: 085/115.5757",
      callNLMob: "NL Mobiel: 06 11 28 43 00",
      emailUs: "Or email:"
    }
  },

  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À Propos",
      reviews: "Avis",
      quote: "Devis",
      requestQuote: "Demander un Devis"
    },
    // Hero Section
    hero: {
      badge: "Entreprise de Nettoyage Professionnelle",
      title1: "Nettoyage",
      title2: "Impeccable",
      title3: "Garanti",
      description: "Solutions de nettoyage fiables et de qualité pour les entreprises aux Pays-Bas et en Belgique. La qualité et la satisfaction client sont nos priorités.",
      cta1: "Devis Gratuit",
      cta2: "Nos Services",
      banner: "Calculez votre prix instantanément via notre chatbot",
      bannerSub: "Obtenez un calcul de prix exact basé sur votre situation",
      bannerCta: "Démarrer le Calcul",
      stats: {
        founded: "Fondé en",
        retention: "Fidélisation Client",
        activeIn: "Actif en"
      }
    },
    // Services Section
    services: {
      badge: "Nos Services",
      title1: "Solutions de Nettoyage",
      title2: "Sur Mesure",
      vacation: {
        title: "Service Maisons de Vacances",
        description: "Nettoyage complet, blanchisserie et accueil des hôtes pour locations de vacances."
      },
      office: {
        title: "Nettoyage de Bureaux",
        description: "Nettoyage professionnel des espaces de bureau pour un environnement de travail productif."
      },
      industrial: {
        title: "Nettoyage Industriel",
        description: "Nettoyage spécialisé pour usines, entrepôts et installations de production."
      },
      osmosis: {
        title: "Lavage de Vitres à l'Osmose",
        description: "Résultats sans traces avec de l'eau osmosée pure. Sûr et écologique jusqu'à de grandes hauteurs."
      },
      solar: {
        title: "Nettoyage de Panneaux Solaires",
        description: "Augmentez le rendement de vos panneaux solaires avec un nettoyage professionnel. Jusqu'à 30% de rendement en plus."
      },
      laundry: {
        title: "Services de Blanchisserie",
        description: "Entretien textile sur mesure via HomeCareService pour tous vos besoins de blanchisserie."
      },
      windows: {
        title: "Lavage de Vitres Traditionnel",
        description: "Lavage de vitres classique pour des fenêtres cristallines à tout endroit."
      },
      sanitation: {
        title: "Assainissement & Désinfection",
        description: "Nettoyage professionnel après obstruction de toilettes, rupture de canalisations et dégâts des eaux usées."
      },
      construction: {
        title: "Nettoyage de Fin de Chantier",
        description: "Nettoyage de livraison prêt à emménager après construction neuve ou rénovation. Minutieux et professionnel."
      },
      moveout: {
        title: "Nettoyage après Location/Vente",
        description: "Propriété prête à remettre après location, vente ou déménagement. Du studio à la villa."
      },
      deepclean: {
        title: "Nettoyage en Profondeur",
        description: "Nettoyage approfondi pour habitations et bâtiments. De l'entretien normal à la contamination extrême."
      }
    },
    // Features Section
    features: {
      badge: "Pourquoi Clean-Force",
      title1: "Votre Partenaire en",
      title2: "Hygiène Professionnelle",
      description: "Depuis 2021, nous offrons des solutions de nettoyage fiables et de qualité pour les entreprises aux Pays-Bas et en Belgique. Nos clients fidèles choisissent Clean-Force année après année - cela dit tout sur notre qualité.",
      reliability: {
        title: "Fiabilité",
        description: "Personnel certifié avec vérification des antécédents pour votre tranquillité d'esprit."
      },
      flexibility: {
        title: "Flexibilité",
        description: "Horaires personnalisables adaptés à votre activité."
      },
      quality: {
        title: "Qualité",
        description: "Résultats de haute qualité avec des techniques et ressources modernes."
      },
      satisfaction: {
        title: "Satisfaction Client",
        description: "Attention personnelle et communication rapide garanties."
      }
    },
    // Reviews Section
    reviews: {
      badge: "Avis Google",
      title1: "Ce Que Nos Clients",
      title2: "Disent",
      reviewsOn: "avis sur Google",
      poweredBy: "Powered by Google",
      viewAll: "Voir tous les avis sur Google",
      qrTitle: "Satisfait de notre service?",
      qrDescription: "Scannez le code QR pour laisser un avis",
      qrLink: "ici"
    },
    // Portfolio Section
    portfolio: {
      badge: "Nos Travaux",
      title1: "Projets",
      title2: "Récents",
      description: "Découvrez nos travaux récents d'assainissement et de désinfection. Ces photos montrent des situations où Clean-Force a été sollicité pour un nettoyage et une désinfection professionnels.",
      category: "Assainissement & Désinfection",
      cta: "Besoin d'aide aussi?",
      ctaButton: "Contactez-Nous"
    },
    gallery: {
      badge: "Résultats",
      title1: "Avant &",
      title2: "Après",
      description: "Découvrez la différence Clean-Force. Faites glisser le curseur pour comparer.",
      empty: "Bientôt disponible — nos clients partagent leurs résultats.",
      cta: "Vous voulez un tel résultat?",
      ctaButton: "Demander un Devis",
      permission: "Partagé avec la permission du client"
    },
    // Quote Form
    quote: {
      badge: "Devis Gratuit",
      title1: "Demandez Votre",
      title2: "Devis",
      success: {
        title: "Merci!",
        message: "Votre demande de devis a été reçue. Nous vous contacterons bientôt.",
        newRequest: "Nouvelle Demande"
      },
      form: {
        name: "Nom",
        namePlaceholder: "Votre nom",
        email: "Email",
        emailPlaceholder: "votre@email.com",
        phone: "Téléphone",
        phonePlaceholder: "+32 4 12345678",
        company: "Nom de l'Entreprise",
        companyPlaceholder: "Votre entreprise (optionnel)",
        serviceType: "Type de Service",
        selectService: "Sélectionnez un service",
        frequency: "Fréquence",
        selectFrequency: "Sélectionnez la fréquence",
        details: "Détails Supplémentaires",
        detailsPlaceholder: "Décrivez vos besoins et votre situation...",
        submit: "Demander un Devis",
        submitting: "Envoi..."
      },
      services: {
        vacation: "Service Maisons de Vacances",
        office: "Nettoyage de Bureaux",
        industrial: "Nettoyage Industriel",
        osmosis: "Lavage de Vitres à l'Osmose",
        solar: "Nettoyage de Panneaux Solaires",
        windows: "Lavage de Vitres Traditionnel",
        laundry: "Services de Blanchisserie",
        other: "Autre"
      },
      frequencies: {
        onCall: "Sur appel (maisons de vacances)",
        daily: "Quotidien",
        weekly: "Hebdomadaire",
        biweekly: "Bi-hebdomadaire",
        monthly: "Mensuel",
        once: "Unique"
      }
    },
    // Footer
    footer: {
      description: "Clean-Force BV offre des services de nettoyage professionnels et des solutions de blanchisserie pour les entreprises aux Pays-Bas et en Belgique. La qualité et la fiabilité sont au cœur de notre activité.",
      quickLinks: "Liens Rapides",
      contact: "Contact",
      rights: "Tous droits réservés.",
      terms: "Conditions Générales",
      privacy: "Politique de Confidentialité"
    },
    // Blog
    blog: {
      badge: "Blog",
      title: "Connaissances & Conseils",
      subtitle: "Articles pratiques sur le nettoyage professionnel, l'entretien et l'hygiène",
      readMore: "Lire la suite",
      backToBlog: "Retour au blog",
      backToHome: "Retour à l'accueil",
      publishedOn: "Publié le",
      by: "par",
      relatedArticles: "Articles similaires",
      noArticles: "Aucun article disponible pour le moment.",
      categories: {
        ramenwassen: "Lavage de Vitres",
        zonnepanelen: "Panneaux Solaires",
        kantoorschoonmaak: "Nettoyage de Bureau",
        sanering: "Assainissement"
      }
    },
    // Chat
    chat: {
      title: "Assistant Clean-Force",
      online: "En ligne",
      welcome: "Bienvenue chez Clean-Force! Je suis votre assistant virtuel. Comment puis-je vous aider aujourd'hui? N'hésitez pas à poser des questions sur nos services, prix ou emplacements.",
      placeholder: "Tapez votre question...",
      error: "Désolé, une erreur s'est produite. Veuillez réessayer plus tard ou contactez-nous directement au 085/115.5757 (NL), 06 11 28 43 00 (NL Mobile) ou 0484/448.854 (BE).",
      priceCalculation: "Demandez un calcul de prix exact via notre assistant chat!",
      priceDescription: "Notre assistant IA calcule directement votre prix en fonction du nombre de fenêtres, de l'emplacement et de la fréquence."
    },
    // Service Pages
    servicePage: {
      backToHome: "Retour à l'Accueil",
      benefits: "Avantages",
      whatWeOffer: "Ce Que Nous Offrons",
      pricing: "Tarifs",
      interested: "Intéressé par",
      contactUs: "Contactez-nous pour un devis gratuit ou posez votre question via notre assistant chat.",
      requestQuote: "Demander un Devis",
      callBE: "BE: 0484/448.854",
      callNL: "NL: 085/115.5757",
      callNLMob: "NL Mobiel: 06 11 28 43 00",
      emailUs: "Ou par email:"
    }
  },

  de: {
    // Navigation
    nav: {
      home: "Startseite",
      services: "Dienstleistungen",
      about: "Über Uns",
      reviews: "Bewertungen",
      quote: "Angebot",
      requestQuote: "Angebot Anfordern"
    },
    // Hero Section
    hero: {
      badge: "Professionelles Reinigungsunternehmen",
      title1: "Makellose",
      title2: "Reinigung",
      title3: "Garantiert",
      description: "Zuverlässige und qualitativ hochwertige Reinigungslösungen für Unternehmen in den Niederlanden und Belgien. Qualität und Kundenzufriedenheit stehen an erster Stelle.",
      cta1: "Kostenloses Angebot",
      cta2: "Unsere Dienstleistungen",
      banner: "Berechnen Sie Ihren Preis sofort über unseren Chatbot",
      bannerSub: "Erhalten Sie eine exakte Preisberechnung basierend auf Ihrer Situation",
      bannerCta: "Preisberechnung Starten",
      stats: {
        founded: "Gegründet",
        retention: "Kundenbindung",
        activeIn: "Aktiv in"
      }
    },
    // Services Section
    services: {
      badge: "Unsere Dienstleistungen",
      title1: "Reinigungslösungen",
      title2: "Maßgeschneidert",
      vacation: {
        title: "Ferienhäuser Service",
        description: "Komplettreinigung, Wäscheservice und Gäste-Check-in für Ferienunterkünfte."
      },
      office: {
        title: "Büroreinigung",
        description: "Professionelle Reinigung von Büroräumen für eine produktive Arbeitsumgebung."
      },
      industrial: {
        title: "Industriereinigung",
        description: "Spezialisierte Reinigung für Fabriken, Lager und Produktionsstätten."
      },
      osmosis: {
        title: "Osmose Fensterreinigung",
        description: "Streifenfreie Ergebnisse mit reinem Osmosewasser. Sicher und umweltfreundlich bis in große Höhen."
      },
      solar: {
        title: "Solaranlagen Reinigung",
        description: "Steigern Sie den Ertrag Ihrer Solaranlagen mit professioneller Reinigung. Bis zu 30% mehr Ertrag."
      },
      laundry: {
        title: "Wäscheservice",
        description: "Maßgeschneiderte Textilpflege über HomeCareService für alle Ihre Wäschebedürfnisse."
      },
      windows: {
        title: "Traditionelle Fensterreinigung",
        description: "Klassische Fensterreinigung für kristallklare Fenster an jedem Standort."
      },
      sanitation: {
        title: "Sanierung & Desinfektion",
        description: "Professionelle Reinigung nach Toilettenverstopfungen, Rohrbrüchen und Abwasserschäden."
      },
      construction: {
        title: "Bauendreinigung",
        description: "Bezugsfertige Übergabereinigung nach Neubau oder Renovierung. Gründlich und professionell."
      },
      moveout: {
        title: "Reinigung nach Vermietung/Verkauf",
        description: "Immobilie übergabefertig nach Vermietung, Verkauf oder Umzug. Vom Studio bis zur Villa."
      },
      deepclean: {
        title: "Grundreinigung",
        description: "Gründliche Tiefenreinigung für Wohnungen und Gebäude. Von normaler Pflege bis extremer Verschmutzung."
      }
    },
    // Features Section
    features: {
      badge: "Warum Clean-Force",
      title1: "Ihr Partner für",
      title2: "Professionelle Hygiene",
      description: "Seit 2021 bieten wir zuverlässige und qualitativ hochwertige Reinigungslösungen für Unternehmen in den Niederlanden und Belgien. Unsere treuen Kunden wählen Jahr für Jahr Clean-Force - das sagt alles über unsere Qualität.",
      reliability: {
        title: "Zuverlässigkeit",
        description: "Zertifiziertes Personal mit Hintergrundüberprüfung für Ihre Sicherheit."
      },
      flexibility: {
        title: "Flexibilität",
        description: "Anpassbare Zeitpläne, die zu Ihrem Geschäftsbetrieb passen."
      },
      quality: {
        title: "Qualität",
        description: "Hochwertige Ergebnisse mit modernen Techniken und Mitteln."
      },
      satisfaction: {
        title: "Kundenzufriedenheit",
        description: "Persönliche Betreuung und schnelle Kommunikation garantiert."
      }
    },
    // Reviews Section
    reviews: {
      badge: "Google Bewertungen",
      title1: "Was Unsere Kunden",
      title2: "Sagen",
      reviewsOn: "Bewertungen auf Google",
      poweredBy: "Powered by Google",
      viewAll: "Alle Bewertungen auf Google ansehen",
      qrTitle: "Zufrieden mit unserem Service?",
      qrDescription: "Scannen Sie den QR-Code, um eine Bewertung abzugeben",
      qrLink: "hier"
    },
    // Portfolio Section
    portfolio: {
      badge: "Unsere Arbeit",
      title1: "Aktuelle",
      title2: "Projekte",
      description: "Sehen Sie sich unsere aktuellen Sanierungs- und Desinfektionsarbeiten an. Diese Fotos zeigen Situationen, in denen Clean-Force für professionelle Reinigung und Desinfektion beauftragt wurde.",
      category: "Sanierung & Desinfektion",
      cta: "Auch Hilfe benötigt?",
      ctaButton: "Kontaktieren Sie Uns"
    },
    gallery: {
      badge: "Ergebnisse",
      title1: "Vorher &",
      title2: "Nachher",
      description: "Sehen Sie den Unterschied, den Clean-Force macht. Schieben Sie den Regler zum Vergleichen.",
      empty: "Demnächst verfügbar — unsere Kunden teilen ihre Ergebnisse.",
      cta: "Möchten Sie auch solche Ergebnisse?",
      ctaButton: "Angebot Anfordern",
      permission: "Mit Genehmigung des Kunden geteilt"
    },
    // Quote Form
    quote: {
      badge: "Kostenloses Angebot",
      title1: "Fordern Sie Ihr",
      title2: "Angebot An",
      success: {
        title: "Vielen Dank!",
        message: "Ihre Angebotsanfrage wurde erhalten. Wir werden uns in Kürze mit Ihnen in Verbindung setzen.",
        newRequest: "Neue Anfrage"
      },
      form: {
        name: "Name",
        namePlaceholder: "Ihr Name",
        email: "E-Mail",
        emailPlaceholder: "ihre@email.de",
        phone: "Telefon",
        phonePlaceholder: "+31 6 12345678",
        company: "Firmenname",
        companyPlaceholder: "Ihre Firma (optional)",
        serviceType: "Dienstleistungsart",
        selectService: "Wählen Sie eine Dienstleistung",
        frequency: "Häufigkeit",
        selectFrequency: "Häufigkeit wählen",
        details: "Zusätzliche Details",
        detailsPlaceholder: "Beschreiben Sie Ihre Wünsche und Situation...",
        submit: "Angebot Anfordern",
        submitting: "Wird gesendet..."
      },
      services: {
        vacation: "Ferienhäuser Service",
        office: "Büroreinigung",
        industrial: "Industriereinigung",
        osmosis: "Osmose Fensterreinigung",
        solar: "Solaranlagen Reinigung",
        windows: "Traditionelle Fensterreinigung",
        laundry: "Wäscheservice",
        other: "Sonstiges"
      },
      frequencies: {
        onCall: "Auf Abruf (Ferienhäuser)",
        daily: "Täglich",
        weekly: "Wöchentlich",
        biweekly: "Zweiwöchentlich",
        monthly: "Monatlich",
        once: "Einmalig"
      }
    },
    // Footer
    footer: {
      description: "Clean-Force BV bietet professionelle Reinigungsdienste und Wäschelösungen für Unternehmen in den Niederlanden und Belgien. Qualität und Zuverlässigkeit stehen im Mittelpunkt.",
      quickLinks: "Schnelllinks",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
      terms: "Allgemeine Geschäftsbedingungen",
      privacy: "Datenschutzerklärung"
    },
    // Blog
    blog: {
      badge: "Blog",
      title: "Wissen & Tipps",
      subtitle: "Praktische Artikel über professionelle Reinigung, Wartung und Hygiene",
      readMore: "Weiterlesen",
      backToBlog: "Zurück zum Blog",
      backToHome: "Zurück zur Startseite",
      publishedOn: "Veröffentlicht am",
      by: "von",
      relatedArticles: "Ähnliche Artikel",
      noArticles: "Noch keine Artikel verfügbar.",
      categories: {
        ramenwassen: "Fensterreinigung",
        zonnepanelen: "Solaranlagen",
        kantoorschoonmaak: "Büroreinigung",
        sanering: "Sanierung"
      }
    },
    // Chat
    chat: {
      title: "Clean-Force Assistent",
      online: "Online",
      welcome: "Willkommen bei Clean-Force! Ich bin Ihr virtueller Assistent. Wie kann ich Ihnen heute helfen? Fragen Sie gerne nach unseren Dienstleistungen, Preisen oder Standorten.",
      placeholder: "Geben Sie Ihre Frage ein...",
      error: "Entschuldigung, etwas ist schief gelaufen. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns direkt unter 085/115.5757 (NL), 06 11 28 43 00 (NL Mobil) oder 0484/448.854 (BE).",
      priceCalculation: "Fordern Sie eine genaue Preisberechnung über unseren Chat-Assistenten an!",
      priceDescription: "Unser KI-Assistent berechnet Ihren Preis direkt basierend auf der Anzahl der Fenster, dem Standort und der Häufigkeit."
    },
    // Service Pages
    servicePage: {
      backToHome: "Zurück zur Startseite",
      benefits: "Vorteile",
      whatWeOffer: "Was Wir Bieten",
      pricing: "Preise",
      interested: "Interesse an",
      contactUs: "Kontaktieren Sie uns für ein kostenloses Angebot oder stellen Sie Ihre Frage über unseren Chat-Assistenten.",
      requestQuote: "Angebot Anfordern",
      callBE: "BE: 0484/448.854",
      callNL: "NL: 085/115.5757",
      callNLMob: "NL Mobiel: 06 11 28 43 00",
      emailUs: "Oder per E-Mail:"
    }
  }
};

export default translations;
;
